"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RyversTouchAbilityHandler = exports.RyversTouchActorAbilityFactory = exports.RyversTouchAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Random_1 = require("../../utils/Random");
class RyversTouchAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.RyversTouch;
        this.__typeName = "RyversTouch";
    }
}
exports.RyversTouchAbilityArgs = RyversTouchAbilityArgs;
let RyversTouchActorAbilityFactory = class RyversTouchActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("RyversTouch", "OneAllies", 1);
    }
};
RyversTouchActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("RyversTouch")
], RyversTouchActorAbilityFactory);
exports.RyversTouchActorAbilityFactory = RyversTouchActorAbilityFactory;
let RyversTouchAbilityHandler = class RyversTouchAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        let targetIds = ability.args.target.actorIds.slice(0, 1);
        if (container.hasAttribute(ability.invokerId, "Charm_Avenger_1")) {
            targetIds = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies);
        }
        container.applyAbilityAnimation({
            sequence,
            animatedId: ability.invokerId,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            onAnimated(sequence) {
                targetIds.forEach(targetId => {
                    var _a;
                    container.applyHealing({
                        sequence,
                        healerId: ability.invokerId,
                        targetId,
                        amount: container.getPercentOfBaseHealth(ability.invokerId, 4),
                    });
                    const harmfulEffectIds = container.getHarmfulEffects(targetId);
                    container.cancelEffect(sequence, (_a = (0, Random_1.randomElement)(harmfulEffectIds)) === null || _a === void 0 ? void 0 : _a.id);
                });
            },
        });
    }
};
RyversTouchAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.RyversTouch)
], RyversTouchAbilityHandler);
exports.RyversTouchAbilityHandler = RyversTouchAbilityHandler;
